let cn = {
    WEBAPPNAME: "仲量联行招投标平台",
    WEBSITEHOME: "网站首页",
    LOGOUT: "退出登录",
    ONLINESERVICE: "在线客服",
    HELLO: "您好！",
    WELCOMEMSG: "您好，欢迎来到招投标平台",
    WELCOMEMSG_NOLOGIN: "您好，请登录",
    FREEREG: "免费注册",
    LOGINUSER: "登录人：",

    PROMPT: "提示",
    LISTMORE: "更多...",

    TENONELIST: "暂无相关记录",
    NONELIST: "找不到相关记录",
    NONESELECT: "暂无可选项",

    EMPTY: "空",
    CLEARSELLIST: "清空列表",
    SORT: "排序",
    SELECT: "选择",
    CONTROL: "操作",
    COUNT: "数量",
    CONFIRM: "确认",
    CANCEL: "取消",
    YES: "是",
    NO: "否",
    EDIT: "编辑",
    DELETE: "删除",
    SAVE: "保存",
    SAVING: "保存中...",
    SAVEANDUSE: "保存并启用",
    SAVEANDUSING: "保存启用中...",
    QUERY: "查询",
    SEARCH: "搜索",
    STARTPAGE: "首页",
    PREVPAGE: "上一页",
    NEXTPAGE: "下一页",
    ENDPAGE: "尾页",
    TOTALREC: "共有",
    RECORDS: "条记录",
    TOTALPAGE: "共",
    PAGES: "页",
    RETURNHOME: "返回主页",
    RETURN: "返回",
    SUBMIT: "提交",
    MORE: "更多",
    DOWNLOAD: "下载",
    UPLOAD: "上传",

    CHINA0086: "中国 0086",
    HONKONG0852: "中国香港 0852",
    MACAO0853: "中国澳门 0853",
    TAIWAN0886: "中国台湾 0886",

    GETCODE: "获取验证码",

    ANDROIDDOWNLOAD: "Android版下载",
    IOSDOWNLOAD: "IOS版下载",

    ABOUTUS: "关于我们",
    ADSERVICE: "广告服务",
    CONTACTUS: "联系我们",
    LINKS: "友情链接",
    RECRUITMENT: "人才招聘",
    SALESALLIANCE: "销售联盟",
    MERCHANTSSETTLED: "商家入驻",
    COMPHONE: "电话：0755-2557 3967",
    COMADDRNAME: "总部",
    COMADDR: "深圳市龙岗区龙岗大道8288号大运软件小镇19栋3C19-21室",
    RESEARCHBASENAME: "研发基地",
    RESEARCHBASE: "江门市蓬江区发展大道63号摩根国际商业1座1102室",
    COPYRIGHT: "版权所有."
};
let tw = {
    WEBAPPNAME: "仲量聯行投標平臺",
    WEBSITEHOME: "網站首頁",
    LOGOUT: "退出登錄",
    ONLINESERVICE: "在線客服",
    HELLO: "您好！",
    WELCOMEMSG: "您好，歡迎來到招投標平臺",
    WELCOMEMSG_NOLOGIN: "您好，請登錄",
    FREEREG: "免費註冊",
    LOGINUSER: "登錄人：",

    PROMPT: "提示",
    LISTMORE: "更多...",

    TENONELIST: "暫無相關記錄",
    NONELIST: "找不到相關記錄",
    NONESELECT: "暫無可選項",

    EMPTY: "空",
    CLEARSELLIST: "清空列表",
    SORT: "排序",
    SELECT: "選擇",
    CONTROL: "操作",
    COUNT: "數量",
    CONFIRM: "確認",
    CANCEL: "取消",
    YES: "是",
    NO: "否",
    EDIT: "編輯",
    DELETE: "刪除",
    SAVE: "保存",
    SAVING: "保存中...",
    SAVEANDUSE: "保存並啟用",
    SAVEANDUSING: "保存啟用中...",
    QUERY: "查詢",
    SEARCH: "搜索",
    STARTPAGE: "首頁",
    PREVPAGE: "上一頁",
    NEXTPAGE: "下一頁",
    ENDPAGE: "尾頁",
    TOTALREC: "共有",
    RECORDS: "條記錄",
    TOTALPAGE: "共",
    PAGES: "頁",
    RETURNHOME: "返回主頁",
    RETURN: "返回",
    SUBMIT: "提交",
    MORE: "更多",
    DOWNLOAD: "下載",
    UPLOAD: "上傳",

    CHINA0086: "中國 0086",
    HONKONG0852: "中國香港 0852",
    MACAO0853: "中國澳門 0853",
    TAIWAN0886: "中國台灣 0886",

    GETCODE: "獲取驗證碼",

    ANDROIDDOWNLOAD: "Android版下載",
    IOSDOWNLOAD: "IOS版下載",

    ABOUTUS: "關於我們",
    ADSERVICE: "廣告服務",
    CONTACTUS: "聯繫我們",
    LINKS: "友情鏈接",
    RECRUITMENT: "人才招聘",
    SALESALLIANCE: "銷售聯盟",
    MERCHANTSSETTLED: "商家入駐",
    COMPHONE: "電話：0755-2557 3967",
    COMADDRNAME: "總部",
    COMADDR: "深圳市龍崗區龍崗大道8288號大運軟件小鎮19棟3C19-21室",
    RESEARCHBASENAME: "研發基地",
    RESEARCHBASE: "江門市蓬江區發展大道63號摩根國際商業1座1102室",
    COPYRIGHT: "版權所有."
};
let en = {
    WEBAPPNAME: 'JLL Tendering Platform',
    WEBSITEHOME: 'Home Page',
    LOGOUT: 'Sign Out',
    ONLINESERVICE: 'Customer Service',
    HELLO: 'Hello!',
    WELCOMEMSG: 'Welcome to JLL e-Tendering Supplier Portal',
    WELCOMEMSG_NOLOGIN: 'Hello, Please login',
    FREEREG: 'Register',
    LOGINUSER: "User: ",

    PROMPT: 'Tips',
    LISTMORE: "More...",

    TENONELIST: 'No Related Records',
    NONELIST: 'No Related Records',
    NONESELECT: 'No options available',

    EMPTY: "Empty",
    CLEARSELLIST: 'Clear List',
    SORT: 'Sort',
    SELECT: 'Select',
    CONTROL: 'Operate',
    COUNT: 'Quantity',
    CONFIRM: 'Confirm',
    CANCEL: 'Cancel',
    YES: "Yes",
    NO: "No",
    EDIT: 'Edit',
    DELETE: 'Delete',
    SAVE: 'Save',
    SAVING: 'Saving...',
    SAVEANDUSE: 'Save and Enable',
    SAVEANDUSING: 'Save Enabled...',
    QUERY: 'Search',
    SEARCH: 'Search',
    STARTPAGE: 'First Page',
    PREVPAGE: 'Prev Page',
    NEXTPAGE: 'Next Page',
    ENDPAGE: 'Last Page',
    TOTALREC: 'Total ',
    RECORDS: 'record(s)',
    TOTALPAGE: 'Total ',
    PAGES: 'page(s)',
    RETURNHOME: 'Return Home Page',
    RETURN: "Back",
    SUBMIT: "Submit",
    MORE: "More",
    DOWNLOAD: "Download",
    UPLOAD: "Upload",

    CHINA0086: "CN 0086",
    HONKONG0852: "HK 0852",
    MACAO0853: "MO 0853",
    TAIWAN0886: "TW 0886",

    GETCODE: "Get Code",

    ANDROIDDOWNLOAD: "Android Download",
    IOSDOWNLOAD: "IOS Download",

    ABOUTUS: 'About Us',
    ADSERVICE: 'Advertisement',
    CONTACTUS: 'Contact Us',
    LINKS: 'Links',
    RECRUITMENT: 'Recruitment',
    SALESALLIANCE: 'Sales Alliance',
    MERCHANTSSETTLED: 'Partnership',
    COMPHONE: 'Tel: 0755-2557 3967',
    COMADDRNAME: 'Company',
    COMADDR: 'Room 3C19-21, Building 19, Dayun Software Town, No. 8288 Longgang Avenue, Longgang District, Shenzhen',
    RESEARCHBASENAME: 'R&D Center',
    RESEARCHBASE: 'Room 1102, Block 1, Morgan International Business, 63 Development Avenue, Pengjiang District, Jiangmen City',
    COPYRIGHT: 'All Rights Reserved.'
}

export {
    cn,
    tw,
    en
}